/** Helpers for API-sourced effective Orígenes (grant ∩ catalog already applied server-side). */

/** ZTE when the user has it; otherwise the first catalog code. Null when none. */
export function defaultEnvioSmsOrigen(effectiveOrigenes) {
  const list = effectiveOrigenes || [];
  if (list.includes('ZTE')) return 'ZTE';
  return list[0] ?? null;
}

/** True when two or more effective Orígenes are available. */
export function shouldShowEnvioSmsOrigenSelector(effectiveOrigenes) {
  return (effectiveOrigenes || []).length > 1;
}

/** True when the API effective Orígenes list is non-empty. */
export function canAccessEnvioSms(effectiveOrigenes) {
  return (effectiveOrigenes || []).length > 0;
}
